// Drawola Studio — built-in template registry (Phase 3). Fork-only.
//
// Order here is the order of the cards in the Studio's create strip, right
// after the blank card. Every `build` is lazy: nothing renders, measures or
// allocates until a card's preview is generated or a card is clicked.

import { buildFlowchartTemplate } from "./flowchart";
import { buildMindmapTemplate } from "./mindmap";
import { buildWeeklyPlannerTemplate } from "./weeklyPlanner";
import { buildWireframeTemplate } from "./wireframe";

import type { StudioTemplate } from "./types";

export const STUDIO_TEMPLATES: readonly StudioTemplate[] = [
  {
    id: "mindmap",
    nameKey: "studio.templates.mindmap.name",
    descriptionKey: "studio.templates.mindmap.description",
    build: buildMindmapTemplate,
  },
  {
    id: "flowchart",
    nameKey: "studio.templates.flowchart.name",
    descriptionKey: "studio.templates.flowchart.description",
    build: buildFlowchartTemplate,
  },
  {
    id: "wireframe",
    nameKey: "studio.templates.wireframe.name",
    descriptionKey: "studio.templates.wireframe.description",
    build: buildWireframeTemplate,
  },
  {
    id: "weeklyPlanner",
    nameKey: "studio.templates.weeklyPlanner.name",
    descriptionKey: "studio.templates.weeklyPlanner.description",
    build: buildWeeklyPlannerTemplate,
  },
];

export { useTemplatePreviews } from "./preview";

export type { StudioTemplate, TemplateScene } from "./types";
